import React from "react";
import styles from "./Error.module.css";
import { getDomain } from "../../utils";

const ErrorPage = () => {
  return (
    <div className={styles.root}>
      <p>
        ERROR: Cannot find domain <strong>{`"${getDomain()}"`}</strong>
      </p>
    </div>
  );
};

export default ErrorPage;
